import api from "./api";

export const postAddMember = async (body) => {
  return api
    .post({
      endpoint: "/member/create-by-owner",
      port: process.env.REACT_APP_PORT_VENUE,
      body,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
